import moment from 'moment'
const convertDateTHtoJS = (dateTime) => {
  // (25/12/2021 15:09:21.0) to (js format)
  const date = dateTime.trim().split(' ')[0].split('/').reverse().join('-')
  const time = dateTime.trim().split(' ')[1]
  return date + ' ' + time
}

const convertToDateFormat = (value) => {
  const date = moment(value).format('YYYY-MM-DD')
  return date
}

const convertToDateTime = (value) => {
  const date = moment(value).format('DD/MM/YYYY hh:mm:ss')
  return date
}

const convertToDateNotTime = (value) => {
  // const date = new Date(value)
  const result = moment(value).format('DD/MM/YYYY')
  return result
}

const convertToDateMonth = (value) => {
  // const date = new Date(value)
  const result = moment(value).format('MM/YYYY')
  return result
}

const convertToDateFullMonth = (value) => {
  // const date = new Date(value)
  const result = moment(value).format('MMMM YYYY')
  return result
}

function urlEndWith (url) {
  // eslint-disable-next-line prefer-regex-literals
  const regx = new RegExp('[^/]+(?=$|$)')
  return url.match(regx)[0]
}

function dateFormat (date) {
  return (new Date(date)).toISOString().split('T')[0]
}

export { convertDateTHtoJS, urlEndWith, convertToDateTime, convertToDateNotTime, dateFormat, convertToDateMonth, convertToDateFullMonth, convertToDateFormat }
